@if (navigationStateService.isLoggedIn) {
  <div class="app-container" [class.production]="globals.isProduction">
    <mat-toolbar
      [ngClass]="globals.applicationTitle == 'CaseFLO Training' ? 'training-app-header' : 'app-header'"
      class="app-toolbar"
    >
      <mat-toolbar-row>
        <button
          mat-icon-button
          [attr.aria-label]="open == true ? 'Collapse app sidebar navigation' : 'Expand app sidebar navigation'"
          (click)="open = !open"
          class="button-border-transparent"
        >
          <img
            src="assets/images/caseflo.png"
            width="25"
            height="25"
            class="d-inline-block align-top"
            alt="{{ navigationStateService.applicationSettings?.applicationTitle }}"
          />
        </button>

        <a routerLink="/home" class="app-header appMainLink">
          <span class="toolbar-title">
            {{ navigationStateService.applicationSettings?.applicationTitle }}
          </span>
        </a>

        <span class="toolbar-spacer"></span>

        <span class="toolbar-section">
          <span>
            <ng-container>
              <span *transloco="let t">{{ t('Language') }}</span>
            </ng-container>
          </span>

          <button
            mat-icon-button
            [attr.aria-label]="'activeLanguage'"
            [matMenuTriggerFor]="langMenu"
            class="header-icon button-border-transparent"
          >
            <mat-icon>{{ langIcon }}</mat-icon>
          </button>
        </span>

        <span class="toolbar-spacer"></span>

        <span class="toolbar-section">
          <!-- <cf2-backend-status></cf2-backend-status> -->
          {{ navigationStateService.user.displayName }}
          {{ navigationStateService.user.userRoleAbbreviation }}:
          {{ navigationStateService.user.siteName }}

          <button
            mat-icon-button
            [attr.aria-label]="'Settings' | transloco"
            [matMenuTriggerFor]="authMenu"
            class="header-icon button-border-transparent"
          >
            <mat-icon>{{ profileIcon }}</mat-icon>
          </button>
        </span>
      </mat-toolbar-row>
    </mat-toolbar>

    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav
        #sidenav
        [opened]="open"
        [mode]="'side'"
        [class.small]="open === false"
        class="app-sidenav"
      >
        <mat-nav-list
          class="sidenav-content"
          [class.small]="open === false"
        >
          <div
            class="module-menu"
            [class.small]="open === false"
          >
            @if (userStateSvc.modules$ | async; as sideNavLinks) {
              <ng-container *ngFor="let module of sideNavLinks">
                <a
                  mat-list-item
                  class="nav-list-item"
                  [ngClass]="{ 'selected': rla.isActive }"
                  [class.small]="open === false"
                  [routerLink]="[module.path]"
                  routerLinkActive="selected"
                  #rla="routerLinkActive"
                >
                  <mat-icon
                    matListItemIcon
                    class="nav-icon"
                    [attr.title]="module.label"
                  >
                    {{ module.icon }}
                  </mat-icon>

                  @if (module.key === 'integration') {
                    <span
                      matListItemTitle
                      style="font-weight: 500 !important;"
                    >
                      <span>
                        {{ module.label }}
                        <span class="badge-count">
                          {{globals.dashCount}}
                        </span>
                      </span>
                    </span>
                  } @else {
                    <span
                      matListItemTitle
                      style="font-weight: 500 !important;"
                    >
                      <span>{{ module.label }}</span>
                    </span>
                  }
                </a>

                <!-- Level 2 -->
                @if (rla.isActive) {
                  <mat-nav-list
                    class="children"
                    style="padding: 0px !important"
                  >
                    <ng-container *ngFor="let item of module.children">

                      @if (item.key !== 'surveys' || surveysEnabled === true) {
                        <a
                          mat-list-item
                          class="nav-list-item children"
                          [class.small]="open === false"
                          [routerLink]="[module.path, item.path]"
                          routerLinkActive="subSelected"
                          #childRla="routerLinkActive"
                        >
                          @if (!item.fontAwesomeIcon) {
                            <mat-icon
                              matListItemIcon
                              class="children-icon"
                              [attr.title]="item.label"
                            >
                              {{ item.icon }}
                            </mat-icon>
                          } @else {
                            <i
                              matListItemIcon
                              class="fa fa-{{ item.icon }} fa-icon children-icon"
                              aria-hidden="true"
                              [attr.title]="item.label"
                            ></i>
                          }

                          <span
                            matListItemTitle
                            class="children"
                            [class.label-hidden]="open === false"
                          >
                            {{ item.label }}
                          </span>
                        </a>

                        <!-- Level 3 -->
                        @if (childRla.isActive) {
                          <ng-container *ngFor="let itemChild of item.children">
                            <mat-list class="children">

                              @if (itemChild.external) {
                                <a
                                  mat-list-item
                                  class="nav-list-item children item-children"
                                  [href]="getExternalUrl(itemChild.path)"
                                  target="_blank"
                                >
                                  @if (!itemChild.fontAwesomeIcon) {
                                    <mat-icon
                                      matListItemIcon
                                      class="children-icon"
                                      [attr.title]="itemChild.label"
                                    >
                                      {{ itemChild.icon }}
                                    </mat-icon>
                                  } @else {
                                    <i
                                      matListItemIcon
                                      class="fa fa-{{ itemChild.icon }} fa-icon children-icon"
                                      aria-hidden="true"
                                      [attr.title]="itemChild.label"
                                    ></i>
                                  }

                                  <span
                                    matListItemTitle
                                    class="children"
                                    [class.label-hidden]="open === false"
                                  >
                                    {{ itemChild.label }}
                                  </span>
                                </a>
                              } @else {
                                <a
                                  mat-list-item
                                  class="nav-list-item children item-children"
                                  [class.small]="open === false"
                                  [routerLink]="itemChild?.exactPath
                                    ? [itemChild.path]
                                    : [module.path, item.path, itemChild.path]"
                                  routerLinkActive="subSelected"
                                >
                                  @if (!itemChild.fontAwesomeIcon) {
                                    <mat-icon
                                      matListItemIcon
                                      class="children-icon"
                                      [attr.title]="itemChild.label"
                                    >
                                      {{ itemChild.icon }}
                                    </mat-icon>
                                  } @else {
                                    <i
                                      matListItemIcon
                                      class="fa fa-{{ itemChild.icon }} fa-icon children-icon"
                                      aria-hidden="true"
                                      [attr.title]="itemChild.label"
                                    ></i>
                                  }

                                  <span
                                    matListItemTitle
                                    class="children"
                                    [class.label-hidden]="open === false"
                                  >
                                    {{ itemChild.label }}
                                  </span>
                                </a>
                              }

                            </mat-list>
                          </ng-container>
                        }
                        <!-- /Level 3 -->
                      }

                    </ng-container>
                  </mat-nav-list>
                }
                <!-- /Level 2 -->

              </ng-container>
            }
          </div>
        </mat-nav-list>
      </mat-sidenav>

      <mat-sidenav-content class="sidenav-main-content">
        <router-outlet></router-outlet>
        <!-- <ng-content></ng-content> -->
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
}

<mat-menu #authMenu="matMenu">
  <ng-container>
    <button
      mat-menu-item
      [attr.aria-label]="'activeLanguage'"
      [matMenuTriggerFor]="langMenu"
      *transloco="let t"
    >
      {{ t('Language') }}
    </button>

    <button
      mat-menu-item
      (click)="msalService.logoutRedirect().subscribe()"
    >
      Logout
    </button>
  </ng-container>

  @if (headerMenuLinks.length > 0) {
    <div mat-subheader>
      Application Settings
    </div>
  }

  <mat-list-item *ngFor="let link of headerMenuLinks">
    @if (link.external == false) {
      <a
        matLine
        mat-menu-item
        (click)="navigate(link.path, {})"
      >
        {{ link.label }}
      </a>
    }

    @if (link.external == true) {
      <a
        matLine
        mat-menu-item
        href="{{ link.path }}"
      >
        {{ link.label }}
      </a>
    }
  </mat-list-item>
</mat-menu>

<mat-menu #langMenu="matMenu">
  <ng-template matMenuContent>
    <button
      mat-menu-item
      (click)="switchLanguage('en')"
    >
      English
    </button>

    <button
      mat-menu-item
      (click)="switchLanguage('fr')"
    >
      Français
    </button>
  </ng-template>
</mat-menu>

<ng-template #loggedOut></ng-template>